// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import GlobalStyles from '../../../config/styles';

const styles = theme => ({
  contactInfoContainer: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: 30,
    marginLeft: 20,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
    [theme.breakpoints.down(720)]: {
      marginLeft: 0,
    },
  },
  blueText: {
    marginTop: 30,
    color: GlobalStyles.color.COLOR_SECONDARY,
  },
  phoneEmailLink: {
    color: GlobalStyles.color.COLOR_PRIMARY,
    marginTop: -30,
    fontSize: GlobalStyles.fonts.FONT_SIZE_LARGE,
    '&:hover': {
      textDecoration: 'none',
      letterSpacing: 1.02,
      color: GlobalStyles.color.COLOR_BLACK_GREY,
    },
    [theme.breakpoints.down(720)]: {
      marginTop: -20,
      fontSize: GlobalStyles.fonts.FONT_SIZE,
    },
  },
  mainContainer: {
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  },
  image: {
    width: 700,
    position: 'absolute',
    left: -70,
    [theme.breakpoints.down(820)]: {
      left: 0,
    },
    [theme.breakpoints.down(720)]: {
      width: 600,
    },
    [theme.breakpoints.down(620)]: {
      width: '100%',
      height: 400,
    },
  },
  form: {
    position: 'absolute',
    top: 50,
    right: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingTop: 40,
    paddingBottom: 30,
    width: 400,
    zIndex: 10,
    backgroundColor: GlobalStyles.color.COLOR_PRIMARY,
    boxShadow: GlobalStyles.color.COLOR_SHADOW,
    borderRadius: 10,
    [theme.breakpoints.down(620)]: {
      position: 'static',
      padding: 10,
      width: '95%',
      boxShadow: 'none',
    },
  },
  subContainer: {
    display: 'flex',
    position: 'relative',
    width: 700,
    height: 700,
    flexDirection: 'column',
    margin: '30px 0',
    [theme.breakpoints.down(720)]: {
      width: 600,
    },
    [theme.breakpoints.down(620)]: {
      height: 'fit-content',
      width: '100%',
      alignItems: 'center',
      margin: 0,
    },
  },
  infoContainer: {
    display: 'flex',
    flexDirection: 'column',
    position: 'absolute',
    top: 50,
    width: '50%',
    color: GlobalStyles.color.COLOR_PRIMARY,
    [theme.breakpoints.down(820)]: {
      left: 30,
    },
    [theme.breakpoints.down(720)]: {
      left: 10,
    },
    [theme.breakpoints.down(620)]: {
      position: 'static',
      zIndex: 11,
      width: '100%',
      height: 400,
      alignItems: 'center',
      justifyContent: 'center',
    },
  },
  topInfo: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
  },
  arrowBackContainer: {
    display: 'flex',
    alignItems: 'center',
    position: 'absolute',
    left: 20,
    marginBottom: 1,
    cursor: 'pointer',
    [theme.breakpoints.down(820)]: {
      left: 40,
    },
    [theme.breakpoints.down(620)]: {
      left: 10,
    },
  },
  title: {
    marginTop: 2,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
    fontSize: GlobalStyles.fonts.FONT_SIZE_TITLE,
    [theme.breakpoints.down(720)]: {
      fontSize: GlobalStyles.fonts.FONT_SIZE,
    },
  },
  nameText: {
    fontSize: 70,
    color: 'rgba(250, 250, 250, 0.3)',
    [theme.breakpoints.down(720)]: {
      fontSize: 50,
    },
  },
  dataElement: {
    display: 'flex',
    flexDirection: 'column',
  },
  link: {
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_REGULAR,
    fontSize: GlobalStyles.fonts.FONT_SIZE,
  }
});

export default styles;
